import { Paper, Box, IconButton, Stack, Typography } from "@mui/material"
import CloseIcon from "@mui/icons-material/CloseOutlined"
import { lightGreen } from "@mui/material/colors"
import { useTheme } from "@mui/material/styles"

export const LeftPage = (props: any) => {
  const theme = useTheme()
  return (
    <Stack
      sx={{
        left: 14,
        top: 133,
        minWidth: "300px",
        maxWidth: "536px",
        borderRadius: "8px",
        backgroundColor: theme.transBkColor?.light,
        maxHeight: `calc(100% - 114px)`,
        position: "absolute",
        boxShadow: 6,
        overflow: "hidden",
        ...props.sx,
      }}
      direction="column"
    >
      <Stack
        sx={{
          p: "24px 32px 16px 32px",
          width: "100%",
          backgroundColor: "#f1f1f2",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          ...props.headersx,
        }}
        justifyContent="space-between"
        direction={"row"}
      >
        <Typography variant="h6" sx={{ fontSize: 24, lineHeight: 0 }}>
          {props.title}
        </Typography>
        <IconButton
          sx={{
            width: 30,
            height: 30,
          }}
          onClick={props.onClose}
        >
          <CloseIcon />
        </IconButton>
      </Stack>
      {props.headContent}
      <Box
        sx={{
          p: "24px",
          backgroundColor: "background.paper",
          overflow: "auto",
          ...props.contentsx,
        }}
      >
        {props.content}
      </Box>
      {props.actions ? (
        <Box sx={{ width: "100%" }}> {props.actions}</Box>
      ) : (
        <Box sx={{ width: "100%", height: "20px" }}></Box>
      )}
      {props.children}
    </Stack>
  )
}
